import { SHIP_HOLD_FIRE_INTERVAL_MS } from 'asteroids-shared/constants'

const DEADZONE = .25

const BTN = {
  fireA: 0,
  brakeB: 1,
  fireX: 2,
  bumperL: 4,
  bumperR: 5,
  triggerL: 6,
  triggerR: 7,
  dpadUp: 12,
  dpadDown: 13,
  dpadLeft: 14,
  dpadRight: 15
}

export default class Gamepad {
  #onConnect = (e) => {
    if (this.index == null) this.index = e.gamepad.index
  }

  #onDisconnect = (e) => {
    if (this.index === e.gamepad.index) this.index = null
  }

  constructor({ onActivity } = {}) {
    this.onActivity = onActivity
    this.index = null
    this.wasActive = false
    this.fireWasDown = false
    this.lastFireEmitMs = -Infinity
  }

  start() {
    window.addEventListener('gamepadconnected', this.#onConnect)
    window.addEventListener('gamepaddisconnected', this.#onDisconnect)
    const pads = navigator.getGamepads()
    for (const pad of pads) {
      if (pad) {
        this.index = pad.index
        break
      }
    }
  }

  stop() {
    window.removeEventListener('gamepadconnected', this.#onConnect)
    window.removeEventListener('gamepaddisconnected', this.#onDisconnect)
    this.index = null
    this.wasActive = false
    this.fireWasDown = false
    this.lastFireEmitMs = -Infinity
  }

  poll() {
    const keys = { left: false, right: false, up: false, down: false, firePresses: 0 }
    if (this.index == null) return keys

    const pad = navigator.getGamepads()[this.index]
    if (!pad) return keys

    const leftX = pad.axes[0]
    const rightX = pad.axes[2]
    const pressed = i => pad.buttons[i]?.pressed === true

    keys.left = pressed(BTN.dpadLeft) || leftX < -DEADZONE || rightX < -DEADZONE
    keys.right = pressed(BTN.dpadRight) || leftX > DEADZONE || rightX > DEADZONE
    keys.up = pressed(BTN.dpadUp) || pressed(BTN.triggerL)
    keys.down = pressed(BTN.dpadDown) || pressed(BTN.brakeB) || pressed(BTN.bumperL)

    const fireDown = pressed(BTN.fireA) || pressed(BTN.fireX)
      || pressed(BTN.bumperR) || pressed(BTN.triggerR)

    if (fireDown) {
      const now = performance.now()
      if (!this.fireWasDown) {
        keys.firePresses = 1
        this.lastFireEmitMs = now
      } else if (now - this.lastFireEmitMs >= SHIP_HOLD_FIRE_INTERVAL_MS) {
        keys.firePresses = 1
        this.lastFireEmitMs = now
      }
    }
    this.fireWasDown = fireDown

    const anyActive = keys.left || keys.right || keys.up || keys.down || fireDown
    if (anyActive && !this.wasActive) this.onActivity?.()
    this.wasActive = anyActive

    return keys
  }
}
